import { render, staticRenderFns } from "./ModelSix.vue?vue&type=template&id=86e87788&scoped=true"
import script from "./ModelSix.vue?vue&type=script&lang=js"
export * from "./ModelSix.vue?vue&type=script&lang=js"
import style0 from "./ModelSix.vue?vue&type=style&index=0&id=86e87788&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e87788",
  null
  
)

export default component.exports